// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2dyud","alightCenter":"styles_alightCenter__1Vcrl"};